import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../lib/api';

const MAX_RETRIES = 2;

/**
 * React Query defaults: retry network/5xx failures (up to 2 times) but never 4xx — a validation error,
 * 401, 403, 404 or 409 will not change on retry. Mutations never retry (they may not be idempotent).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < MAX_RETRIES;
        },
        refetchOnWindowFocus: true,
        staleTime: 15_000,
      },
      mutations: { retry: false },
    },
  });
}
